export const PageApi = {
  _login: 'admin-sessions',
  //_logout: 'Lgn/VmLogOut',
  _logout: 'admin-sessions',
  _updateLogin: 'Lgn/VmVldTkn',
  _generateTocken: 'auth/token',
  _refreshTocken: 'auth/refresh-token',


  _obtenerPuntos: 'device/by-status/',
  _actualizarPuntos: 'device/',
  _actualizarPuntosAll: 'device/updateAll',

  _crearPuntos: 'device/by-city/',
  _actualizarStatuPuntos: 'device/',

  _obtenerMultimedia: 'device/',
  _crearMultimedia: 'multimedia/by-device/',


  _obtenerProvincias: 'state/by-status/',


  _obtenerCantones: 'city/All/state/',



  _obtenerMarcas: 'brand/by-status/',
  _crearMarcas: 'brand',
  _actualizarMarcas: 'brand/',


  _obtenerModelo: 'model/by-status/All/brand/',
  _crearModelo: 'model/brand/',
  _actualizarModelo: 'model/',




  _obtenerDetallePuntos: 'deviceDetail/by-status/All/by-device/',
  _crearDetallePuntos: 'deviceDetail/by-device/',
  _updateDetallePuntos: 'deviceDetail/',


  _obtenerDocumentos: '/document/by-status/',
  _crearDocumentos: '/document',
  _updateDocumentos: '/document/',


  _obtenerParametros: '/admin/parameter/by-status/',
  _crearParametros: '/admin/parameter',
  _updateParametros: '/admin/parameter/',


  _obtenerDetalleParametros: '/admin/parameter/detail/All/header/',
  _crearDetalleParametros: '/admin/parameter/detail/',
  _updateDetalleParametros: '/admin/parameter/detail/',
  _getalllparametros: '/admin/parameter/detail/All/header/',



  _obtenerPersonaByStatus: '/person/by-status/All',
  _obtenerPersonaByRole: '/person/by-status/All/by-role/',
  _obtenerPersonaByIdentificacion: '/person/by-identification/',
  _obtenerPersonaByCedula: '/person/',
  _migrarAutoPerson: '/person/migracion',


  

  _obtenerPersonaCompany: '/person/by-company/',
  _crearPersona: '/person',
  _updatePersona: 'person/',

  _crearCustomer: '/customer/person/',
  _updateCustomer: '/customer/',


  _obtenerRole: '/rol/by-status/All',
  _crearRol: '/rol',
  _updateRol: '/rol/',

  _crearRolUser: '/rolUser/by-user/',
  _obtenerRoleUser: '/rolUser/by-user/',


  _obtenerMarital: '/marital/status/All',

  _obtenerLegalPerson: '/legalpersontype/status/All',


  _obtenerGenero:'/genre/by-status/All',


  _crearUser:'/user/person/',
  _updateUser: '/user/',
  _updateUserCompany: '/user/user-company/',

  
  _obtenerStatus: '/status',
  _crearStatus: '/status',
  _updateStatus: '/status/',



  
  _obtenerVehiculos: '/vehicle/by-status/All/by-person/',
  _obtenerVehiculosUser: '/vehicle/by-status/All/by-person-user/',
  _obtenerVehiculosUserFlotas: '/vehicle/by-status/All/by-person-user-flotas/',

  
  _obtenerVehiculosStatus: '/vehicle/by-status/Active/by-person/',
  _actualizarVehiculos: '/vehicle/',
  _crearVehiculos: '/vehicle/',
  _vehicleUser:'/vehicle/',
  _actualizarVehiculosPersona: '/vehicle/vehicle-person-user/',

  _actualizarAllVehiculos: '/vehicle/updateAll-vehicles-user/',
  _actualizarAllUsers: '/person/updateAll-user/',



  _obtenerSubscripcion: '/subscription/vehicle/',

  _asigarClienteEmpresa: '/user/user-company-vehicle/',



  _obtenerPlanesUser: '/user-parameter/by-user/',

  _agregarUserParameter: '/user-parameter/user/',

  _actualizarUserParameter: '/user-parameter/parameter/detail/',

  _crearSubs: 'subscription/vehicle-flotas/',
  _cancelSubs: 'subscription/cancelById/',

};
